module.exports = __webpack_public_path__ + "assets-cabinet/img/aba-logo.e0e33c04.svg";